import React, { Component } from "react";

import * as actions from "../../services/actions/restaurant.actions";
import { fetcher } from "../../services/sagas/fetcher.saga";
import { Localized } from 'fluent-react/compat';
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import queryString from "query-string";
import { connect } from "react-redux";
import config from "../../config";

class Stripe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stripeAccountId: false,
      displayError: false,
      errorMessage: "",
      redirect: false
    };
  }

  async componentDidMount() {
    const searchParse = queryString.parse(this.props.location.search);
    const { code } = searchParse;
    const { restaurantId } = this.props;

    if (code) this.props.action.createTokenRestaurant(code, restaurantId);
    const result = await fetcher(
      "GET",
      `restaurant/admin/info-stripe/${restaurantId}`,
      {},
      this.props.token
    );
    this.setState({ stripeAccountId: result.data.tokenExist });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.tokenStripeCreated) {
      this.setState({ redirect: true });
    }
    if (nextProps && !nextProps.tokenStripeCreated && nextProps.messageToken) {
      this.setState({
        displayError: true,
        errorMessage: nextProps.messageToken
      });
    }
  }

  render() {
    const { stripeAccountId } = this.state;
    const { redirect, displayError, errorMessage } = this.state;
    return (
      <div id="integration" className="container">
       {/*  <h3>
          <Localized id="tr-admin-connect-stripe" />
        </h3> */}
        <div className="pure-g">
          <div className="pure-u-md-1 pure-u-lg-2-5">
            <section className="section-fb">
              <h4 className="title-fb">
                <Localized id="tr-admin-create-account-stripe" />
              </h4>

              <div className="link container-button-stripe">
                <a
                  href={`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${
                    config.keyRedirectionStripe
                  }&scope=read_write`}
                  className="stripe-connect light-blue"
                >
                  <span>Connect with Stripe</span>
                </a>
              </div>
            </section>
          </div>
          <div className="pure-u-md-1 pure-u-lg-3-5">
            <section id="laddition-stripe">
              <h4>
                <Localized id="tr-admin-account-associate" />
              </h4>
              {displayError ? (
                <p>{errorMessage}</p>
              ) : (
                <div className="container-button-account-stripe">
                  <span
                    className={
                      stripeAccountId
                        ? "button-stripe-account account-connected"
                        : "button-stripe-account account-not-connected"
                    }
                  >
                    {stripeAccountId ? (
                      <Localized id="tr-admin-connect" />
                    ) : (
                      <Localized id="tr-admin-not-connect" />
                    )}
                  </span>
                </div>
              )}
            </section>
          </div>
        </div>
        {redirect ? <Redirect to="stripe" /> : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { restaurant } = state;
  return {
    messageToken: restaurant.infoRestaurant.messageToken,
    tokenStripeCreated: restaurant.infoRestaurant.tokenStripeCreated
  };
};

const mapDispatchToProps = dispatch => {
  return {
    action: bindActionCreators(actions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Stripe);
